import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Contributor } from "types/contributor";

let cachedContributors: Contributor[] | null = null;
let contributorsInFlight: Promise<Contributor[]> | null = null;

export const useContributors = (enabled: boolean = true) => {
  const [contributors, setContributors] = React.useState<Contributor[]>(() => cachedContributors || []);
  const [fetching, setFetching] = React.useState(enabled ? !cachedContributors : false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    if (!enabled) return;
    if (cachedContributors) {
      setContributors(cachedContributors);
      setFetching(false);
      return;
    }
    (async () => {
      const data = await getContributors();
      if (data) setContributors(data);
    })();
  }, [enabled]);

  const getContributors = async (): Promise<Contributor[] | null> => {
    if (cachedContributors) return cachedContributors;
    if (contributorsInFlight) return contributorsInFlight;
    try {
      setFetching(true);
      contributorsInFlight = axios
        .get(`${API_BASE_URL}${API_URLS.Contributors}`, {
          headers: { Accept: 'application/json', Authorization: `Bearer ${token}` }
        })
        .then((r) => (r.data?.data || []) as Contributor[]);
      const data = await contributorsInFlight;
      cachedContributors = data;
      return data;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      contributorsInFlight = null;
      setFetching(false);
    }
  };

  return { contributors, fetching };
};
